<template>   
  <div class="col-md-12">
    <barra-navegacao :visiblebutton="true"/>
    <b-row class="text-center">
        <b-col cols="12">          
          <div style="margin-bottom:10px"></div>
             <b-col lg="12" class="my-1">
              <b-form-group
                label="Pesquisar"
                label-for="filter-input"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="sm"
                class="mb-0"
              >
                <b-input-group size="sm">
                  <b-form-input
                    id="filter-input"
                    v-model="filter"
                    type="search"
                    placeholder="Nome ou Número da sala"
                  ></b-form-input>

                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''">Limpar</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <div style="margin: 10px"></div>
              <b-card bg-variant="light" style="min-height: 60vh;">
                <div class="col-md-12">                   
                    <div class="overflow-auto">
                      <b-table stacked="md" id="my-table" @filtered="onFiltered" :filter="filter" :filter-included-fields="filterOn" striped small :fields="fields" :items="locais" responsive="sm"  :per-page="perPage" :current-page="currentPage">
                        <template  v-slot:cell(codigo)="data">
                           <span>{{data.item.idSala}}</span>                                         
                        </template>
                        <template  v-slot:cell(descricao)="data">
                           <span>{{data.item.descricaoCompleta}}</span>                                         
                        </template>
                        <template  v-slot:cell(corredor)="data">
                           <span>{{ data.item.corredor ? data.item.corredor.descricao : '-' }}</span>                                         
                        </template>
                        <template  v-slot:cell(visualizar)="data">
                            <b-button @click="visualizar(data.item)" class="v-button" size="sm" style="background-color: #303f9f; margin-right: 5px"><b-icon icon="search"></b-icon></b-button>
                            <b-button @click="remover(data.item)" class="v-button" size="sm" variant="danger"><b-icon icon="trash"></b-icon></b-button>                                                                                  
                        </template>
                      </b-table>
                      <div style="float: right">
                        <b-pagination
                        size="sm"
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        aria-controls="my-table"
                        ></b-pagination>
                      </div>                      
                    </div>
                </div>
              </b-card>
              <br>
              <b-card bg-variant="light">
                <div class="row" style="float: right">
                    <b-button v-b-modal.modal-local style="margin-right: 30px; background-color: #303f9f">
                      <b-icon icon="file-earmark"></b-icon>  Novo
                    </b-button>   
                </div>
              </b-card>
        </b-col>
      </b-row>
      <b-modal id="modal-local" ref="modal" title="Local" @hidden="resetModal" @ok="salvar" >
                <b-form-group label="Bloco" label-for="name-input"  >
                    <model-list-select :list="blocos"
                        v-model="local.bloco"
                        option-value="idBloco"
                        option-text="descricao"
                        placeholder="Bloco">
                    </model-list-select>
                </b-form-group>
                <b-form-group label="Andar" label-for="name-input"  >
                    <model-list-select :list="andares"
                        v-model="local.andar"
                        option-value="idAndar"
                        option-text="descricao"
                        placeholder="Andar">
                    </model-list-select>
                </b-form-group>
                <b-form-group label="Corredor" label-for="name-input"  >
                    <model-list-select :list="corredores"
                        v-model="local.corredor"
                        option-value="idCorredor"
                        option-text="descricao"
                        placeholder="Corredor">
                    </model-list-select>
                </b-form-group>
                <b-form-group label="Sala" label-for="name-input"  >
                    <model-list-select :list="salas"
                        v-model="local.sala"
                        option-value="idSala"
                        option-text="descricaoCompleta"
                        placeholder="Sala">
                    </model-list-select>
                </b-form-group>
        </b-modal> 
    </div>
</template>

<script>
import BarraNavegacao from '../../components/BarraNavegacao.vue';
import { ModelListSelect } from 'vue-search-select'

export default {
  components: { BarraNavegacao, ModelListSelect },

  data(){
    return{
      blocos: [],
      andares: [],
      corredores: [],
      salas: [],
      locais: [],
      local:{
          idLocal: null,
          sala: {},
          corredor: null,
          bloco: {},
          andar: {}
      },
      fields: [{ key: 'bloco.descricao', label: 'Bloco' , class:'text-center',sortByFormatted: true},
               { key: 'andar.descricao', label: 'Andar' , class:'text-center',sortByFormatted: true},
               { key: 'corredor', label: 'Corredor' , class:'text-center',sortByFormatted: true},
               { key: 'sala.descricaoCompleta', label: 'Sala' , class:'text-center',sortByFormatted: true},
               { key: 'visualizar', label: 'Visualizar' , class:'text-center'}],
      
      perPage: 10,
      currentPage: 1,
      rows: 10000,
      filter: null,
      filterOn: [],
    }
  },

  created(){
    this.listarBlocos();
    this.listarAndares();
    this.listarCorredores();
    this.listarSalas();
    this.listarLocal();
    this.validaAcesso();
  },

  methods: {

    alertaMensager(mensagem,titulo,tipo){
          this.$fire({
              title: titulo,
              text: mensagem,
              type: tipo,
              }).then(r => {
               r.value;
            });
        },

    salvar(){
        if(!this.local.corredor || !this.local.corredor.idCorredor) {
             this.alertaMensager("O campo Corredor é obrigatório","","error");
             return;
        }

        let payload = {
           bloco: this.local.bloco,
           andar: this.local.andar,
           corredor: this.local.corredor,
           sala: this.local.sala
        };
        if (this.local.idLocal) {
            payload.idCorredorSala = this.local.idLocal;
        }
        this.$http.post('/corredor-salas', payload).then(() => {
            this.alertaMensager("Salvo com sucesso","","success");   
            this.listarLocal();    
            this.$bvModal.hide('modal-local');
        }).catch(() => {
            this.alertaMensager("Erro ao salvar o local","","error");
        });
    },

    validaAcesso(){
        this.$http.get('/gerencia', this.sala).then()
    },

    resetModal() {
        this.local = {
          idLocal: null,
          sala: {},
          bloco: {},
          andar: {},
          corredor: null
        };
    },

    onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.rows = filteredItems.length
        this.currentPage = 1
    },

    listarLocal(){
      Promise.all([
        this.$http.get("/local"),
        this.$http.get("/corredor-salas")
      ]).then(([resLocal, resCorredor]) => {
         let corredoresList = resCorredor.data.map(item => ({...item, tipo: 'corredor'}));
         
         // Create a Set of signatures for mapped CorredorSala records
         let mappedSignatures = new Set(
             corredoresList.map(c => `${c.bloco.idBloco}-${c.andar.idAndar}-${c.sala.idSala}`)
         );

         // Filter out AndarSala records that already exist in CorredorSala
         let andaresList = resLocal.data
             .filter(item => !mappedSignatures.has(`${item.bloco.idBloco}-${item.andar.idAndar}-${item.sala.idSala}`))
             .map(item => ({...item, tipo: 'andar'}));
             
         this.locais = [...corredoresList, ...andaresList];
         this.rows = this.locais.length;
      }) 
    },

    listarSalas(){
      this.$http.get("/sala").then(res => {
         this.salas = res.data;
      }) 
    },

    listarBlocos(){
      this.$http.get("/bloco").then(res => {
         this.blocos = res.data;
      }) 
    },

    listarAndares(){
      this.$http.get("/andar").then(res => {
         this.andares = res.data; 
      }) 
    },

    listarCorredores(){
      this.$http.get("/corredores").then(res => {
         this.corredores = res.data; 
      }) 
    },

    visualizar(item){
      if(item.tipo === 'corredor') {
          this.local = {
              idLocal: item.idCorredorSala,
              bloco: item.bloco,
              andar: item.andar,
              corredor: item.corredor,
              sala: item.sala
          };
          this.$bvModal.show('modal-local');
      } else {
          this.$http.get("/local/"+item.idAndarSala).then(res => {
             let data = res.data;
             this.local = {
                idLocal: data.idAndarSala,
                bloco: data.bloco,
                andar: data.andar,
                corredor: null,
                sala: data.sala
             };
             this.$bvModal.show('modal-local');
          })
      }
    },

    remover(item){
        this.$confirm("Tem certeza que deseja excluir o local ?").then(() => {
            if(item.tipo === 'corredor') {
                this.$http.delete("/corredor-salas/"+item.idCorredorSala).then(() => {
                    this.alertaMensager("","Removido com sucesso","success");
                    this.listarLocal();
                }) 
            } else {
                this.$http.delete("/local/"+item.idAndarSala).then(res => {
                    this.alertaMensager("",res.data,"success");
                    this.listarLocal();
                }) 
            }
        });
      
    }
    
  }
}

</script>

<style>

</style>
